var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTiktok = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.76 2h-3.15v12.94c0 1.54-1.22 2.81-2.73 2.81a2.77 2.77 0 01-2.72-2.8 2.8 2.8 0 012.64-2.82V8.88A5.97 5.97 0 004 14.94 5.98 5.98 0 009.9 21a6 6 0 005.92-6.06V8.31A7.24 7.24 0 0020 9.74V6.49A4.43 4.43 0 0115.76 2z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTiktok);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tiktok.eb946d1fd9b3fdce180e30c81b760568.svg";